// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-param-reassign */
// @ts-expect-error: Flow to TS migration.
import { stringify } from "query-string"
import * as cookies from "@kiwicom/nitro/lib/services/session/cookies"
import { Cookie } from "@kiwicom/cookies"
import * as session from "@kiwicom/nitro/lib/services/session/session"
import { SESSION_ID } from "@kiwicom/nitro/lib/consts/session"

import { AbortError, FetchError } from "./fetchErrors"
import promiseRetry from "./promiseRetry"

// Improvements over basic fetch
// Add content-type header
// Return json in case of success
// Return error detail and text in case of failure
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const hasIgnoreCaseKey = (obj: any, key: string) => {
  const lKey = key.toLocaleLowerCase()
  return Object.keys(obj).some((x) => x.toLocaleLowerCase() === lKey)
}

const JSON_CONTENT_TYPE = "application/json"
const NO_CONTENT = 204

// Attempt for flow types

// FIXME: unify with "RequestOptions"
export type Options = {
  method?: "GET" | "PUT" | "POST" | "DELETE"
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body?: any
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
  headers?: {
    [key: string]: string
  }
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  query?: any
  retry?: number
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cache?: any
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  credentials?: any
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  integrity?: any
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  keepalive?: any
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mode?: any
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  redirect?: any
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  referrer?: any
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  referrerPolicy?: any
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  signal?: any
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  window?: any
  disableTracking?: boolean
}

export type Settings = {
  requestId?: boolean
}

export const FETCH_ABORT_ERROR = "AbortError"
export const FETCH_NETWORK_ERROR = "TypeError"

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-inferrable-types
const handleError = (data: any, response: Response, requestId: boolean = false) => {
  const err = new FetchError(response.statusText)
  err.status = response.status
  err.statusText = response.statusText
  err.data = data
  if (requestId) {
    err.headerRequestId = response.headers.get("request-id")
  }

  throw err
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-inferrable-types
export const handleResponse = (response: Response, requestId: boolean = false) => {
  const headerRequestId = response.headers.get("request-id")
  if (response.ok) {
    if (response.status === NO_CONTENT) return null
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/prefer-optional-chain
    const contentType = response.headers && response.headers.get("content-type")
    if (!contentType || contentType.includes("application/json")) {
      if (requestId && headerRequestId) {
        return response.json().then((data) => ({ ...data, headerRequestId }))
      }
      return response.json()
    }
    return response.text()
  }

  // error
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (response.json) {
    return response.json().then((data) => handleError(data, response))
  }
  return response.text().then((data) => handleError(data, response))
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const removeNullValues = (obj: any) =>
  Object.keys(obj)
    .filter((k) => obj[k] == null)
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    .forEach((k) => delete obj[k])

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getUrlWithQuery = (url: string, query: any) => {
  const separator = url.includes("?") ? "&" : "?"
  // filter out null and undefined values,
  // queryString.stringify serialize it other way then we need
  if (typeof query === "object") removeNullValues(query)
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  return `${url}${separator}${stringify(query)}`
}

export default function jsonFetch(url: string, customOptions?: Options, settings: Settings = {}) {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  const options = { ...(customOptions || {}) } as const
  // @ts-expect-error: Flow to TS migration.
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  options.headers = options.headers || {}
  const missingHeader = (key: string) => !hasIgnoreCaseKey(options.headers, key)
  if (missingHeader("Content-Type")) {
    options.headers["Content-Type"] = JSON_CONTENT_TYPE
  }
  if (missingHeader("Accept")) {
    options.headers.Accept = JSON_CONTENT_TYPE
  }

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (typeof window !== "undefined" && window.SP_GLOBALS && !options.disableTracking) {
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    options.headers["X-WHOIAM"] = cookies.load(Cookie.USER_ID) || ""
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    options.headers["X-WHOIAM-SESSION"] = session.load(SESSION_ID) || ""
  }

  if (options.body) {
    if (typeof options.body === "object") {
      // @ts-expect-error: Flow to TS migration.
      options.body = JSON.stringify(options.body)
    }
    if (options.method && options.method.toUpperCase() === "GET") {
      throw new Error("Wrong method, cannot send body with GET")
    }
    // @ts-expect-error: Flow to TS migration.
    if (!options.method) options.method = "POST"
  } else {
    // Edge browser don't work when you send options.body = null
    // @ts-expect-error: Flow to TS migration.
    delete options.body
  }

  // Warn non-standard
  if (options.query) {
    url = getUrlWithQuery(url, options.query)
    // @ts-expect-error: Flow to TS migration.
    delete options.query
  }

  if (options.retry && options.retry > 1) {
    const run = () =>
      fetch(url, options).then((response) => {
        // abort retrying if the resource doesn't exist
        if (response.status === 404) {
          throw new AbortError(response.statusText)
        }

        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        return handleResponse(response, settings.requestId || false)
      })
    return promiseRetry(run, {
      retries: options.retry,
      factor: 1.1,
      minTimeout: 10,
      maxTimeout: 500,
    })
  }
  return fetch(url, options).then(handleResponse)
}
